// TestPage.jsx
import React, { useState, useRef, useEffect } from 'react';
import { FiUser, FiEdit2, FiArrowLeft } from 'react-icons/fi';

const TestPage = () => {
  const [showProfileOverlay, setShowProfileOverlay] = useState(false);
  const [userName, setUserName] = useState('User');
  const [userAvatar, setUserAvatar] = useState(null);
  const [isEditingName, setIsEditingName] = useState(false);
  const [tempUserName, setTempUserName] = useState('');

  // Handle file selection for avatar
  const handleChooseFromGallery = () => {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*';
    
    fileInput.onchange = (e) => {
      if (e.target.files && e.target.files.length > 0) {
        const file = e.target.files[0];
        const reader = new FileReader();
        
        reader.onload = (event) => {
          const photoDataUrl = event.target.result;
          console.log('Avatar image loaded:', file.name, 'Size:', file.size, 'Type:', file.type);
          setUserAvatar(photoDataUrl);
        };
        
        reader.onerror = (error) => {
          console.error('File reading error:', error);
          alert('Failed to load the selected image. Please try again.');
        };
        
        reader.readAsDataURL(file);
      }
    };
    
    // Trigger file input click
    fileInput.click();
  };

  const handleSaveProfile = () => {
    setUserName(tempUserName);
    setIsEditingName(false);
    setShowProfileOverlay(false);
    console.log('Profile saved - Name:', tempUserName, 'Avatar:', userAvatar ? 'Set' : 'Not set');
  };

  const handleCancelProfile = () => {
    setTempUserName(userName);
    setIsEditingName(false);
    setShowProfileOverlay(false);
    console.log('Profile changes cancelled');
  };

  const handleEditName = () => {
    setIsEditingName(true);
  };

  // Initialize temp name when overlay opens
  useEffect(() => {
    if (showProfileOverlay) {
      setTempUserName(userName);
    }
  }, [showProfileOverlay, userName]);

  return (
    <>
      <style jsx>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .test-container {
          width: 100%;
          min-height: 100vh;
          background: #2D2D2D;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 20px;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        }

        .test-title {
          color: white;
          font-size: 1.5rem;
          margin-bottom: 30px;
          text-align: center;
        }

        .avatar-circle {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          border: 3px solid #487fd6;
          background: #595959;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          cursor: pointer;
          transition: all 0.2s ease;
          margin-bottom: 20px;
        }

        .avatar-circle:hover {
          border-color: #5998F9;
        }

        .avatar-placeholder {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background: #777;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }

        .avatar-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .test-button {
          background: #5998ff;
          border: none;
          color: white;
          padding: 12px 24px;
          border-radius: 20px;
          cursor: pointer;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          font-size: 1rem;
          margin: 10px;
          transition: background-color 0.2s ease;
        }

        .test-button:hover {
          background: #4880ff;
        }

        .test-button:active {
          background: #3a70e0;
          transform: scale(0.98);
        }

        .button-group {
          display: flex;
          flex-direction: column;
          gap: 10px;
          margin-top: 20px;
        }

        /* Profile Overlay */
        .profile-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100vh;
          background: #2D2D2D;
          z-index: 1002;
          display: flex;
          flex-direction: column;
          padding: 20px;
        }

        .profile-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 30px;
        }

        .profile-back-button {
          background: none;
          border: none;
          color: white;
          font-size: 1.2rem;
          cursor: pointer;
          padding: 8px;
          border-radius: 50%;
          transition: background-color 0.2s ease;
        }

        .profile-back-button:active {
          background: rgba(255, 255, 255, 0.1);
        }

        .profile-title {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          font-size: 1.2rem;
          color: white;
        }

        .profile-save-button {
          background: #5998ff;
          border: none;
          color: white;
          padding: 8px 16px;
          border-radius: 20px;
          cursor: pointer;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          transition: background-color 0.2s ease;
        }

        .profile-save-button:active {
          background: #4880ff;
          transform: scale(0.95);
        }

        .profile-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 30px;
        }

        .profile-avatar-section {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 15px;
        }

        .profile-avatar-large {
          width: 120px;
          height: 120px;
          border-radius: 50%;
          border: 3px solid #487fd6;
          background: #595959;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }

        .profile-avatar-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .change-avatar-button {
          background: #5998ff;
          border: none;
          color: white;
          padding: 10px 20px;
          border-radius: 20px;
          cursor: pointer;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          transition: background-color 0.2s ease;
        }

        .change-avatar-button:active {
          background: #4880ff;
          transform: scale(0.95);
        }

        .profile-name-section {
          width: 100%;
          max-width: 300px;
        }

        .profile-name-label {
          color: white;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          margin-bottom: 10px;
          font-size: 1rem;
        }

        .profile-name-input-wrapper {
          display: flex;
          background-color: #595959;
          border-radius: 30px;
          overflow: hidden;
          position: relative;
        }

        .profile-name-input {
          flex: 1;
          background: transparent;
          border: none;
          outline: none;
          padding: 12px 16px;
          color: white;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          font-size: 1rem;
        }

        .profile-name-input::placeholder {
          color: rgba(255, 255, 255, 0.7);
        }

        .profile-edit-button {
          background: none;
          border: none;
          color: white;
          padding: 12px 16px;
          cursor: pointer;
          transition: color 0.2s ease;
        }

        .profile-edit-button:active {
          color: #cccccc;
        }

        .debug-info {
          color: white;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          font-size: 0.9rem;
          margin-top: 20px;
          text-align: center;
          max-width: 300px;
          background: rgba(0,0,0,0.3);
          padding: 15px;
          border-radius: 8px;
          line-height: 1.4;
        }

        .debug-status {
          margin: 5px 0;
          padding: 2px 0;
        }

        .status-good {
          color: #90EE90;
        }

        .status-bad {
          color: #FFB6C1;
        }
      `}</style>

      <div className="test-container">
        <h1 className="test-title">Avatar Profile Test</h1>
        
        <div className="avatar-circle" onClick={() => setShowProfileOverlay(true)}>
          <div className="avatar-placeholder">
            {userAvatar ? (
              <img src={userAvatar} alt="User Avatar" className="avatar-image" />
            ) : (
              <FiUser size={30} color="#FFFFFF" />
            )}
          </div>
        </div>

        <div className="button-group">
          <button className="test-button" onClick={() => setShowProfileOverlay(true)}>
            Open Profile Overlay
          </button>
          <button className="test-button" onClick={handleChooseFromGallery}>
            Change Avatar (Direct)
          </button>
        </div>

        <div className="debug-info">
          <div className="debug-status">
            Current Avatar: <span className={userAvatar ? "status-good" : "status-bad"}>
              {userAvatar ? "✅ Set" : "❌ Not set"}
            </span>
          </div>
          <div className="debug-status">
            User Name: <span className="status-good">{userName}</span>
          </div>
          <div className="debug-status">
            Instructions: Click the avatar circle or buttons to test
          </div>
          <div className="debug-status" style={{ fontSize: '0.8rem', marginTop: '10px', color: '#cccccc' }}>
            Check browser console for detailed logs
          </div>
        </div>
      </div>

      {/* Profile Overlay */}
      {showProfileOverlay && (
        <div className="profile-overlay">
          <div className="profile-header">
            <button className="profile-back-button" onClick={handleCancelProfile}>
              <FiArrowLeft size={24} />
            </button>
            <div className="profile-title">Profile</div>
            <button className="profile-save-button" onClick={handleSaveProfile}>
              Save
            </button>
          </div>

          <div className="profile-content">
            <div className="profile-avatar-section">
              <div className="profile-avatar-large">
                {userAvatar ? (
                  <img src={userAvatar} alt="User Avatar" className="profile-avatar-image" />
                ) : (
                  <FiUser size={50} color="#FFFFFF" />
                )}
              </div>
              <button className="change-avatar-button" onClick={handleChooseFromGallery}>
                Change Avatar
              </button>
            </div>

            <div className="profile-name-section">
              <div className="profile-name-label">Display Name</div>
              <div className="profile-name-input-wrapper">
                <input
                  type="text"
                  className="profile-name-input"
                  placeholder="Enter your name"
                  value={tempUserName}
                  onChange={(e) => setTempUserName(e.target.value)}
                  readOnly={!isEditingName}
                />
                <button className="profile-edit-button" onClick={handleEditName}>
                  <FiEdit2 size={16} />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TestPage;